module.exports = __webpack_public_path__ + "assets/images/2963ddb0254c540e983e00d39a18bbca.png";